import React, { Component } from 'react';
import { Segment, Popup, Header, Button, Table, Icon, Accordion, Dropdown, Grid } from 'semantic-ui-react';
import accountAPI from '../../../../../../apiCalls/accountAPI'
import ReactToPrint from "react-to-print";
import PrintDailyCanada from './printDailyCanada'
import Confirm from '../confirm'
import { convertEpochToDate } from '../../../../../../util/constants';
import { formatPronoun } from '../../../../../../util';
import { isEmpty, get} from "lodash";
import { downloadInvoiceSignedUrl } from "../../../../../../apiCalls/MainFormRequests";


class PreDailyStatementCanada extends Component {
  constructor() {
    super();
    this.state = {
      values: [],
      activeIndex: -1,
      disabled: {},
      loading: false,
      otherFees: [],
    }
  }

  isEmpty = (obj) => {
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
          return false;
    }
    return true;
  }

  



  handleClick = () => {
    const { cbpDailyIndex } = this.props
    const { activeIndex } = this.state
    const newIndex = activeIndex === cbpDailyIndex ? -1 : cbpDailyIndex

    this.setState({ activeIndex: newIndex })
  }


  formatPrintDate = (date) => {
    return date.split(" ", 1)
  }

  formatMoney = (num) => {
    let value = num && !isEmpty(num) && num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    if (value === 'NaN') {
      value='0.00'
    }
    return value;
  }

  closeConfirm = () => {
    this.setState({ confirm: false })
  }

  downloadDocument = (bucketName,fileName)=>{
    downloadInvoiceSignedUrl(bucketName, fileName)
    .then((res) => {
      let url = get(res, "data.eventMessage.urls[0]", null);
      window.open(url);
    })
    .catch((err) => console.error(err));
  }
  render() {

    const { activeIndex } = this.state

    let formattedAmount = Number(this.props.amount);
    formattedAmount = formattedAmount.toLocaleString('en-US');

    const { cbpDailyIndex, cbpDailyData, importerName, fileName, bucketName, statementNumber, k84Date, groupBy } = this.props
    const collapseStyle = {
      marginLeft: "15px",
      backgroundColor: "white",
      color: "black",
      fontSize: "12px",
      border: "1px solid #1765AE",
      borderRadius: "2px",
      marginRight: "20px",
      height: "20px",
      width: "80px",
      color: "#1765AE",
      lineHeight: "3px",
      width: "104px",
      lineHeight: "13px",
      padding: "0 4px"
    }

    const expandStyle = {
      marginLeft: "15px",
      backgroundColor: "white",
      color: "black",
      fontSize: "12px",
      border: "1px solid #1765AE",
      borderRadius: "2px",
      marginRight: "20px",
      height: "20px",
      width: "80px",
      color: "#1765AE",
      lineHeight: "3px",
      width: "104px",
      lineHeight: "13px",
      padding: "0 4px"
    }

    // {activeIndex === 0 ? <Icon name='minus'/> + 'COLLAPSE' : 'EXPAND'}

    const authColors = {
      orange: {
        color: '#F7B500'
      },
      green: {
        color: '#90CE4E'
      },
      red: {
        color: 'red'
      },
      white: {
        color: 'white'
      }
    }

    const options = [
      { 'key': 0, 'text': 'Authorize', 'value': 'authorize' },
      { 'key': 1, 'text': 'Remove from Statement', 'value': 'remove' }
    ]

    let transactionNumber = 0, Port = 0, duty = 0, sima = 0, excise = 0, gst = 0, interest = 0, penalty = 0, total = 0 ;

    
    if(cbpDailyData.statementEntries) {
        for(let i = 0; i < cbpDailyData.statementEntries.length ; i ++) {

            Port += cbpDailyData.statementEntries[i].Port;
            duty += cbpDailyData.statementEntries[i].duty?parseFloat(cbpDailyData.statementEntries[i].duty):0;
            sima += cbpDailyData.statementEntries[i].sima?parseFloat(cbpDailyData.statementEntries[i].sima):0;
            excise += cbpDailyData.statementEntries[i].excise?parseFloat(cbpDailyData.statementEntries[i].excise):0;
            gst += cbpDailyData.statementEntries[i].gst?parseFloat(cbpDailyData.statementEntries[i].gst):0;
            penalty += cbpDailyData.statementEntries[i].penalty?parseFloat(cbpDailyData.statementEntries[i].penalty):0;
            interest += cbpDailyData.statementEntries[i].interest?parseFloat(cbpDailyData.statementEntries[i].interest):0;
            total += cbpDailyData.statementEntries[i].b3Total?parseFloat(cbpDailyData.statementEntries[i].b3Total):0;
        }    
    }


    return ( 
      <center key={statementNumber}>
        {this.state.confirm  && <Confirm statementNumber={statementNumber} handleAuthorize={this.handleAuthorize.bind(this)} close={this.closeConfirm.bind(this)} numberOfShipments={cbpDailyData.statementEntries.length} amountToAuthorize={this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))}/>}
        <Segment className='cbpPaymentSection'>
          <Accordion>
            <Accordion.Title style={{ cursor: 'default' }} active={activeIndex === cbpDailyIndex} >
              <div className='cbpPaymentSectionHeaderDiv'>
                <Header className='cbpPaymentSectionHeader' as='h3'>
                  <Button onClick={this.handleClick} style={activeIndex === cbpDailyIndex ? collapseStyle : expandStyle}> <Icon name={activeIndex === cbpDailyIndex ? 'minus' : 'add'} /> {activeIndex === cbpDailyIndex ? 'COLLAPSE' : 'EXPAND'} </Button>
                </Header>
                {(groupBy === "CUSTOMER" ) && <div className='headerSectionFour mt4 importerNameCol'>                  
                  <Header className='cbpHeaderText top' as='h5'>IMPORTER NAME</Header>
                  <Header className='cbpHeaderText importerName' as='h4'>{importerName && formatPronoun(importerName)}</Header>
                </div>}

                <div className='headerSectionFour mt4 k84Date'>
                  <Header className='cbpHeaderText top' as='h5'>DN DATE</Header>
                  <Header className='cbpHeaderText' as='h4'>{k84Date}</Header>
                </div>
                

                {/* {activeIndex !== cbpDailyIndex ?
                  <div className='headerSectionAuth'>
                    <Header className='cbpHeaderText' as='h4'>
                      
                    </Header>
                  </div>

                  : null} */}

                <div class="rightPortion">
                  <div className='headerSectionFour mt4 stmtAmount'>
                    <Header className='cbpHeaderText' as='h4'>C$ {formattedAmount}</Header>
                  </div>

                  {/* { !isEmpty(fileName) && !isEmpty(bucketName) ? 
                    <div className='headerSectionFour meta_icon enabled' onClick={() => this.downloadDocument(bucketName, fileName)} style={{cursor:"pointer"}}>
                      <span download="report.xml" className='ui header cbpHeaderText top' className=""> 
                        <img src="/images/download.png" style={{color:"red", display: "block", margin: "10px 8px", width: "20px" }} />
                      </span> 
                    </div> :
                    <div className='headerSectionFour meta_icon'>
                      <span download="report.xml" className='ui header cbpHeaderText top' className=""> 
                      <img src="/images/download_disabled.png" style={{color:"red", display: "block", margin: "10px 8px", width: "20px" }} />
                      </span> 
                    </div>
                  
                  } */}
                  <div className='headerPrint meta_icon enabled'>
                    <ReactToPrint
                        trigger={() => <Icon color="specialBlue" style={{ cursor: 'pointer', marginRight: "0 !important"   }} className='paymentPrint' name='print'/>}
                        content={() => this.componentRef}
                    />
                  </div>
                </div>
              </div>
            </Accordion.Title>
            
            <Accordion.Content active={activeIndex === cbpDailyIndex} >
                        <hr />
                        
                        <Table basic='very' selectable>
                          <Table.Header>
                          <Table.Row>
                              {(groupBy === "NONE" || groupBy === "DATE") && <Table.HeaderCell>IMPORTER NAME</Table.HeaderCell>}
                              <Table.HeaderCell textAlign='right'>TRANSACTION NUMBER</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>CARGO CONTROL NUMBER</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>PURCHASE ORDER</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>DOC TYPE</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>PORT</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>DUTY</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>SIMA</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>EXCISE</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>GST</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>PENALTY</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>INTEREST</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>TOTAL</Table.HeaderCell>
                          </Table.Row>
                          </Table.Header>

                          <Table.Body>
                              { cbpDailyData.statementEntries ? cbpDailyData.statementEntries.map((item, i) => (
                                  <Table.Row key={i} style={{cursor: 'pointer'}} onClick={this.props.open} disabled={this.state.i}>
                                    {(groupBy === "NONE" || groupBy === "DATE") && <Table.Cell>{importerName && formatPronoun(importerName)}</Table.Cell>}
                                    <Table.Cell textAlign='right'>{get(item,"transactionNumber","")}</Table.Cell>
                                    <Table.Cell textAlign='right'>{get(item,"cargoControlNumber","")}</Table.Cell>
                                    <Table.Cell textAlign='right'>{get(item,"poNumber","")}</Table.Cell>
                                    <Table.Cell textAlign='right'>{get(item,"docType","")}</Table.Cell>
                                    <Table.Cell textAlign='right'>{get(item,"Port","")}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(get(item,"duty",0)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(get(item,"sima",0)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(get(item,"excise",0)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(get(item,"gst",0)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(get(item,"penalty",0)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(get(item,"interest",0).toLocaleString())}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(get(item,"b3Total",0)).toLocaleString()}</Table.Cell>
                                  </Table.Row>
                              )) : null }

                                <Table.Row className="totalRow" style={{cursor: 'pointer'}} onClick={this.props.open} >
                                    <Table.Cell><div className="total_label">TOTAL</div></Table.Cell>
                                    {(groupBy === "NONE" || groupBy === "DATE") && <Table.Cell></Table.Cell>}
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell textAlign='right'></Table.Cell>
                                    <Table.Cell textAlign='right'></Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(duty.toFixed(2)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(sima.toFixed(2)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(excise.toFixed(2)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(gst.toFixed(2)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(penalty.toFixed(2)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(interest.toFixed(2)).toLocaleString()}</Table.Cell>
                                    <Table.Cell textAlign='right'>C$ {Number(total.toFixed(2)).toLocaleString()}</Table.Cell>
                                </Table.Row>
                          </Table.Body>
                        </Table>
              <br /><br /><br />
            
            </Accordion.Content>
          </Accordion>
        </Segment>
        <div className='printStatement' style={{ display: 'none'}}>
          <PrintDailyCanada ref={el => (this.componentRef = el)} cbpDailyIndex={this.props.cbpDailyIndex} cbpDailyData={this.props.cbpDailyData} open={this.props.open} />
          {/* <PrintDaily ref={el => (this.componentRef = el)} importerNumber={this.props.importerNumber} key={this.props.key} cbpDailyIndex={this.props.cbpDailyIndex} cbpDailyData={this.props.cbpDailyData} open={this.props.open} /> */}
        </div>
      </center>
    )
  }
}

export default PreDailyStatementCanada;
